import student from '@/api/new-student-unpaid'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().add(7, 'Day').format('DD-MM-YYYY'),
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return student.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  }
}
